import { Link } from 'react-router-dom';
import { BookOpenText } from 'lucide-react';
import { LoginArea } from '@/components/auth/LoginArea';
import { BLOG_TITLE } from '@/lib/blogConfig';

export function BlogHeader() {
  return (
    <header className="sticky top-0 z-40 w-full border-b border-border/60 bg-background/80 backdrop-blur-md">
      <div className="max-w-4xl mx-auto flex items-center justify-between gap-4 px-4 sm:px-6 h-16">
        <Link
          to="/"
          className="group flex items-center gap-3 min-w-0"
          aria-label={`${BLOG_TITLE} — home`}
        >
          <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary/15 text-primary ring-1 ring-primary/25 transition-colors group-hover:bg-primary/25">
            <BookOpenText className="h-5 w-5" />
          </span>
          <span className="truncate font-serif text-lg sm:text-xl font-semibold tracking-tight text-foreground">
            {BLOG_TITLE}
          </span>
        </Link>

        <div className="shrink-0">
          {/* LoginArea shows a "Join" button when logged out, and the user's
              profile avatar with a dropdown (including "Log out") when logged in. */}
          <LoginArea className="max-w-60" />
        </div>
      </div>
    </header>
  );
}
